export const PROFILE_TAB_POST_LIMIT = 12;
export const PROFILE_TAB_ACTIVITY_MONTHS = 6;

/** Prefix of every profile's replies list — any new comment may belong in one. */
export const PROFILE_REPLIES_ROOT_KEY = ["profile", "replies"] as const;

export const profileTabKeys = {
  userPosts: (
    userId: string,
    includePrivatePreview = true,
    limit = PROFILE_TAB_POST_LIMIT,
    mediaOnly = false,
  ) =>
    [
      "posts",
      "feed",
      "user",
      userId,
      limit,
      includePrivatePreview ? "with-preview" : "no-preview",
      ...(mediaOnly ? (["media"] as const) : []),
    ] as const,
  userReplies: (userId: string) =>
    [...PROFILE_REPLIES_ROOT_KEY, userId] as const,
  userActivityPosts: (
    userId: string,
    includePrivatePreview = true,
    limit = PROFILE_TAB_POST_LIMIT,
  ) =>
    [
      "activityPosts",
      "feed",
      limit,
      userId,
      includePrivatePreview ? "with-preview" : "no-preview",
    ] as const,
  activitiesOverview: (userId: string, months = PROFILE_TAB_ACTIVITY_MONTHS) =>
    ["profile", "activities", userId, months] as const,
};
